import React, {FC, ReactNode, useState} from 'react'
import {IViewContext} from "@context/viewContext/types";

export const ViewContext = React.createContext<IViewContext | null>(null)

interface IProps {
    children: ReactNode
}

const ViewContextProvider: FC<IProps> = ({
                                             children,
                                         }) => {


    const [hideSidebar, setHideSidebar] = useState<boolean>(false)


    return (
        <ViewContext.Provider value={{
            hideSidebar, setHideSidebar,
        }}
        >
            {children}
        </ViewContext.Provider>
    );
};

export default ViewContextProvider;
